<template>
  <modal :show.sync="modals.classic" modalClasses="documents-modal">
    <h4 slot="header" class="title text-purple">
      {{ $t("app.modules.orders.documents.current_documents") }}
    </h4>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-md-12" v-for="det in this.detalles" :key="det.idPedido">
          <div class="col-md-12">
            <!--
            <div class="col-md-2 float-left">
              <img style="width: 50%" :src="[server + det.imagenProducto]" />
            </div>
            -->
            <div class="col-md-1 float-left">{{ det.codigoProducto }}</div>
            <div class="col-md-2 float-left">
              <span v-if="$store.state.lang == 'es'">
                {{ det.descripcionProductoEs }}
              </span>
              <span v-else-if="$store.state.lang == 'en'">
                {{ det.descripcionProductoEn }}
              </span>
              <span v-else>
                {{ det.descripcionProducto }}
              </span>
            </div>
            <div class="col-md-2 float-left">
              <b>{{ $t("app.modules.orders.headers.quantity") }}: </b>
              <br />
              {{ det.cantidad }}
              {{ det.unidadMedida }}
            </div>
            <div class="col-md-2 float-left">
              <b>{{ $t("app.modules.orders.headers.delivery_date") }}: </b>
              {{ det.fechaEntregaSolicitada }}
            </div>
            <div class="col-md-2 float-left">
              <b>{{ $t("app.modules.orders.headers.delivery_address") }}: </b>
              {{ det.direccionEntrega }}
            </div>
            <div class="col-md-1 float-left text-center">
              <b>{{ $t("app.modules.orders.headers.subtotal") }}</b>:
              <br/>
              {{ (det.total != null ? det.total : 0) | numFormat('0,0.00') }}
              &nbsp;
              {{ det.moneda }}
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="fechaCreacion"
              :label="$t('app.modules.orders.documents.date_attached')"
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              prop="tipoDocumento"
              :label="$t('app.modules.orders.documents.doc_type')"
              min-width="230"
            >
            </el-table-column>
            <el-table-column
              :label="$t('app.modules.orders.documents.link')"
              min-width="230"
            >
              <template slot-scope="scope">
                <el-link
                  :href="[server + scope.row.documento]"
                  target="_blank"
                  icon="el-icon-document"
                  >{{ $t("app.modules.orders.documents.single") }}</el-link
                >
                <span style="margin-left: 10px">{{ scope.row.date }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div slot="footer" class="text-right">
      <n-button class="btn-secondary" @click.native="cancelDocs">{{
        $t("app.buttons.close")
      }}</n-button>
    </div>
  </modal>
</template>

<script>
import Vue from 'vue'
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'

Vue.filter('numFormat', numFormat(numeral))

export default {
  components: {},
  data() {
    return {
      idDetallePedido: 0,
      detalles: {},
      server: "",
      tableData: [],
      modals: {
        classic: false,
      },
    };
  },
  created(){
    this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  mounted() {
    EventBus.$on("partida-docs", (item) => {
      this.modals.classic = true;
      this.detalles = item;
      // console.log(this.detalles);
      this.idDetallePedido = this.detalles.detallePedido.idDetallePedido;
      // console.log(this.detalles.detallePedido.idDetallePedido);
      this.initPartidaDocs();
    });
  },
  methods: {
    async initPartidaDocs() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      await this.getDocs();

      this.$swal.close();
    },
    async getDocs() {
      var pay_l = {
        id: this.idDetallePedido,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };
      await this.$http
        .post(route("PedidoDocumento/getPedidoDocumentosPortal"), pay_l)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.tableData = response.body.pedidosDocumentos;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    cancelDocs() {
      this.modals.classic = false;
    },
  },
};
</script>

<style>
.modal-dialog.documents-modal {
  max-width: 95% !important;
}
</style>
